import { render, staticRenderFns } from "./food.vue?vue&type=template&id=3cf2e6b3&scoped=true&"
import script from "./food.vue?vue&type=script&lang=js&"
export * from "./food.vue?vue&type=script&lang=js&"
import style0 from "./food.vue?vue&type=style&index=0&id=3cf2e6b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2e6b3",
  null
  
)

export default component.exports